import { Helmet } from 'react-helmet-async';
import CalendarView from '../../../components/dashboard/transports/Calendar/CalendarView';

export default function TransportsCalendar() {
  return (
    <>
      <Helmet>
        <title>Transports Calendar | Platform Solutions</title>
      </Helmet>
      <CalendarView />
    </>
  );
}
